import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_nz2gvy3u76: FaireBrandEntity = {
  token: "b_nz2gvy3u76",
  type: "brand",
  name: "Maker Megan",
  avatarUrl:
    "https://cdn.faire.com/fastly/d30fa7959015ca0c4d1a36c8f1b0515e9ee0cbed2ed51363750b60933a47ecf2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a8a1c34b19a0f63d2e28ebe2f6f705e1e4229a1fe0fa7926d6168befcd96eaa5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d30fa7959015ca0c4d1a36c8f1b0515e9ee0cbed2ed51363750b60933a47ecf2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a8a1c34b19a0f63d2e28ebe2f6f705e1e4229a1fe0fa7926d6168befcd96eaa5.jpeg",
  location: "Hillsborough, NJ, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 9,
  isTopShop: true,
  isInsider: true,
  description:
    "All of my products are lovingly designed at my home in New Jersey with my pup Mishka at my side. I am inspired by my travels and adventures, the sun and the sea, the beauty of every day life, and deep friendship. My wish is that everyone who wears a product of mine will feel confident, beautiful, and empowered. I create and design each product especially for you and hope that you are able to feel the love that has gone into each one when you wear them.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:11.376Z",
    importedBy: "entity-db-cli",
  },
};
